export default "__VITE_ASSET__9feecc08__"